import * as React from 'react';
import * as Charts from '@sail/charts';
import {ResizableContainer} from '../common/ResizableContainer';

const sales = [
  {
    date: 'Jan',
    sold: 1,
    product: 'tables',
  },
  {
    date: 'Jan',
    sold: 2,
    product: 'chairs',
  },
  {
    date: 'Feb',
    sold: 4,
    product: 'tables',
  },
  {
    date: 'Feb',
    sold: 6,
    product: 'chairs',
  },
  {
    date: 'Mar',
    sold: 2,
    product: 'tables',
  },
  {
    date: 'Mar',
    sold: 4,
    product: 'chairs',
  },
  {
    date: 'Apr',
    sold: 7,
    product: 'tables',
  },
  {
    date: 'Apr',
    sold: 9,
    product: 'chairs',
  },
];
export const Color = ({chart}) => {
  const Chart = Charts[chart];
  return (
    <ResizableContainer minWidth={150} width={500} maxWidth={800}>
      <Chart data={sales} x="date" y="sold" color="product" />
    </ResizableContainer>
  );
};
